import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { noop } from 'lodash-es';
import { VehicleEntities } from 'client/data/models/vehicle-v2';
import { DEFAULT_TRIM_CTA_NAME } from 'site-modules/shared/constants/new-core';
import { NewPricingButton } from 'site-modules/personalized-search/components/overview-cta/new-pricing-button';
import { PreprodPricingButton } from 'site-modules/personalized-search/components/overview-cta/preprod-pricing-button';
import { isPreProd, isUsed } from 'site-modules/shared/utils/publication-states';
import { useScrollOnDrawerHide } from 'site-modules/personalized-search/hooks/use-scroll-on-drawer-hide';
import { getLeadFormSrpLinkAttributes } from 'site-modules/personalized-search/utils/get-lead-form-srp-link-attributes';

import './overview-cta.scss';

export function OverviewCta({
  vehicle = null,
  isMobile = false,
  withCollapse = false,
  onRendered = noop,
  onUpdateFilters,
  selectedFilters = null,
  location,
  ...restProps
}) {
  const { onDrawerHide } = useScrollOnDrawerHide();

  useEffect(() => {
    onRendered();
  }, [onRendered]);

  if (!vehicle || isUsed(vehicle.pubStates)) {
    return null;
  }

  const isPreprod = isPreProd(vehicle.pubStates);

  const Component = isPreprod ? PreprodPricingButton : NewPricingButton;

  return (
    <Component
      vehicle={vehicle}
      isMobile={isMobile}
      btnClassName={classnames('overview-cta px-1 py-0_75 rounded-8', {
        'w-100': isMobile,
        'top-view pos-a right-0': !isMobile && !withCollapse,
      })}
      ctaText={DEFAULT_TRIM_CTA_NAME}
      getLeadFormSrpLinkAttributes={getLeadFormSrpLinkAttributes({ onUpdateFilters, selectedFilters, location })}
      onDrawerHide={onDrawerHide}
      {...restProps}
    />
  );
}

OverviewCta.propTypes = {
  vehicle: VehicleEntities.MakeModelSubmodelYear,
  isMobile: PropTypes.bool,
  withCollapse: PropTypes.bool,
  creativeId: PropTypes.string,
  onRendered: PropTypes.func,
  onUpdateFilters: PropTypes.func.isRequired,
  selectedFilters: PropTypes.shape({}),
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
  }).isRequired,
};
